// Autobahn (auto.de redesign) — the legacy MUI MaterialField wrapper now renders the md3 `.mfield`
// markup directly (no MUI). Same API (field, t, label, namespace, sx, multiline, rows, disabled,
// className) and the same mobx-react-form binding via field.bind(), so all ~80 call sites
// (VehicleEdit/VehicleAdd sections, dealer-profile blocks, EmployeeSet, Contact, modals) keep their
// validation/output and only the look changes. `sx` (mostly gridArea) is applied as the wrapper
// style; `multiline` renders a textarea.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
let FormMaterialField = class FormMaterialField extends React.Component {
    render() {
        const { t, field, namespace, label, sx, multiline, rows, disabled, className } = this.props;
        const labelText = label ? label : (field.label ? t(`${namespace ? `${namespace}.` : ''}${field.label}`) : '');
        const hasError = !!field.hasError && !!field.error;
        const isDisabled = !!field.disabled || !!disabled;
        const bound = field.bind();
        return (React.createElement("div", { className: classnames('mfield-group', className), style: sx },
            labelText ? React.createElement("label", { className: 'md-label-sm mfield-label' }, labelText) : null,
            React.createElement("div", { className: 'mfield' + (hasError ? ' mfield--error' : '') + (isDisabled ? ' mfield--disabled' : '') }, multiline ? (React.createElement("textarea", { name: bound.name, id: bound.id, value: isDisabled ? '' : bound.value, onChange: bound.onChange, onBlur: bound.onBlur, disabled: isDisabled, rows: rows || 3, placeholder: '', style: { width: '100%', resize: 'vertical' } })) : (React.createElement("input", { ...bound, type: field.type || 'text', value: isDisabled ? '' : bound.value, disabled: isDisabled, placeholder: '', style: { width: '100%' } }))),
            hasError ? React.createElement("span", { className: 'mfield-error-text' }, field.error) : null));
    }
};
FormMaterialField = __decorate([
    observer
], FormMaterialField);
export default FormMaterialField;
